export default __webpack_public_path__ + "static/media/whiteHouse.41dc6fa9.svg";